import React from 'react';

export const AuditStats = props => {
    const auditStats = props.auditStats;
    const isCorrector = props.isCorrector;
    
    return (
      <div className={"audit-stats paddingLR15 top-section"}>
        <div className={"audit-header"}>
          <div className={"logged-in-header"}>
            {isCorrector ? "Correction" : "Audit"} Stats
          </div>
          <div className={"header-date"}>
            <span className={"date-holder-text"}>Last Updated </span>
            <span>{auditStats.lastUpdated}</span>
          </div>
        </div>
        {isCorrector ? (
          <div className={"text-spacing"}>
            {"Correction Queue Count: " + auditStats.correctorQueueCount}
          </div>
        ) : (
          <div>
            <div className={"text-spacing"}>
              {"Owner LTBM Product Audit Queue Count: " +
                auditStats.nonrelevanceQueueCount}
            </div>
            <div className={"text-spacing"}>
              {"Owner LTBM Service Audit Queue Count: " +
                auditStats.nonrelevanceServiceQueueCount}
            </div>
            <div className={"text-spacing"}>
              {"Onboarding LTBM Product Audit Queue Count: " +
                auditStats.onboardEmpQueueCount}
            </div>
            <div className={"text-spacing"}>
              {"Onboarding LTBM Service Audit Queue Count: " +
                auditStats.onboardEmpServiceQueueCount}
            </div>
            <div className={"text-spacing"}>
              {"Contractor v1 LTBM Product Audit Queue Count: " +
                auditStats.contractorCount}
            </div>
            <div className={"text-spacing"}>
              {"Contractor v1 LTBM Service Audit Queue Count: " +
                auditStats.contractorServiceCount}
            </div>
            <div className={"text-spacing"}>
              {"Contractor v2 LTBM Product Audit Queue Count: " +
                auditStats.contractorV2Count}
            </div>
            <div className={"text-spacing"}>
              {"Contractor v2 LTBM Service Audit Queue Count: " +
                auditStats.contractorV2ServiceCount}
            </div>
            <div className={"text-spacing"}>
              {"Paid Objectionable Product Audit Queue Count: " +
                auditStats.objectionablePaidCount}
            </div>
            <div className={"text-spacing"}>
              {"Non-paid Objectionable Product Audit Queue Count: " +
                auditStats.objectionableFreeCount}
            </div>
            <div className={"text-spacing"}>
              {"Paid Objectionable Service Audit Queue Count: " +
                auditStats.paidObjectionalServiceCount}
            </div>
            <div className={"text-spacing"}>
              {"Non-paid Objectionable Service Audit Queue Count: " +
                auditStats.nonpaidObjectionalServiceCount}
            </div>
            {/*
                <div className={'text-spacing'}>
                    {'Regular Audit Queue Count: '+ auditStats.regularCount }
                </div>
                <div className={'text-spacing'}>
                    {'Paid Regular Service Queue Count: '+ auditStats.paidRegularServiceCount }
                </div>                                    
                <div className={'text-spacing'}>
                    {'Non-Paid Regular Service Queue Count: '+ auditStats.nonpaidRegularServiceCount }
                </div>
                <div className={'text-spacing'}>
                    {'Marketplace Audit Queue Count: '+ auditStats.customSellonlineCount }
                </div>
                <div className={'text-spacing'}>
                    {'Branded Product Audit Queue Count: '+ auditStats.regularBrandCount}
                </div>
                <div className={'text-spacing'}>
                    {'Paid Restricted Service Category Queue Count: '+ auditStats.paidRestrictedServiceCount}
                </div>
                <div className={'text-spacing'}>
                    {'Non-Paid Restricted Service Category Queue Count: '+ auditStats.nonpaidRestrictedServiceCount}
                </div>
                <div className={'text-spacing'}>
                    {'Furlough Audit Queue Count (Pending Catalog Created Disposition): '+ auditStats.furloughPendingCount}
                </div>
                <div className={'text-spacing'}>
                    {'Furlough Audit Queue Count: '+ auditStats.furloughCount}
                </div>
                <div className={'text-spacing'}>
                    {'Contractor v3 Audit Queue Count: '+ auditStats.contractorV3Count}
                </div>
                <div className={'text-spacing'}>
                    {'DB Audit Queue Count (Pending Catalog Created Disposition): '+ auditStats.dbQueuePendingCount}
                </div>
                <div className={'text-spacing'}>
                    {'DB Audit Queue Count: '+ auditStats.dbQueueCount}
                </div>
                <div className={'text-spacing'}>
                    {'Marketplace Audit Queue Count: '+ auditStats.regularCustomCount}
                </div> 
                <div className={'text-spacing'}>
                    {'MRP Compliance Queue Count: '+ auditStats.regularBrandMrpCount}
                </div>
                */}
          </div>
        )}
      </div>
    );
}